module.exports = __webpack_public_path__ + "static/media/QuackHire.a4a5305c.gif";